export var Gender;
(function (Gender) {
    // Male = "Male",
    // Female = "Female",
    Gender["Gentlemen"] = "Gentlemen";
    Gender["Ladies"] = "Ladies";
})(Gender || (Gender = {}));
